export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13979.5dc10ecd.jpg";